export const ConstantSessionStatus = {
    UNAUTHENTICATED: "unauthenticated",
    AUTHENTICATED: "authenticated",
    LOADING: "loading",
}